"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kxAccountAdjustApi = kxAccountAdjustApi;
exports.kxAccountInfoApi = kxAccountInfoApi;
exports.kxAccountListApi = kxAccountListApi;
exports.kxAgentCancelApi = kxAgentCancelApi;
exports.kxAgentInfoApi = kxAgentInfoApi;
exports.kxAgentListApi = kxAgentListApi;
exports.kxAgentPerformanceApi = kxAgentPerformanceApi;
exports.kxAgentPerformanceExportApi = kxAgentPerformanceExportApi;
exports.kxBonusDetailApi = kxBonusDetailApi;
exports.kxBonusListApi = kxBonusListApi;
exports.kxBonusStatApi = kxBonusStatApi;
exports.kxConfigListApi = kxConfigListApi;
exports.kxConfigSaveApi = kxConfigSaveApi;
exports.kxExtractApplyApi = kxExtractApplyApi;
exports.kxExtractListApi = kxExtractListApi;
exports.kxFlowBalanceApi = kxFlowBalanceApi;
exports.kxFlowCommissionApi = kxFlowCommissionApi;
exports.kxFlowHappyFruitApi = kxFlowHappyFruitApi;
exports.kxFlowZoneConsumeApi = kxFlowZoneConsumeApi;
exports.kxInviteListApi = kxInviteListApi;
exports.kxLevelConfigListApi = kxLevelConfigListApi;
exports.kxLevelConfigUpdateApi = kxLevelConfigUpdateApi;
exports.kxLevelUserListApi = kxLevelUserListApi;
exports.kxManualApproveApi = kxManualApproveApi;
exports.kxManualCreateApi = kxManualCreateApi;
exports.kxManualInfoApi = kxManualInfoApi;
exports.kxManualListApi = kxManualListApi;
exports.kxMedalConfigApi = kxMedalConfigApi;
exports.kxMedalConfigUpdateApi = kxMedalConfigUpdateApi;
exports.kxMedalGrantApi = kxMedalGrantApi;
exports.kxMedalRevokeApi = kxMedalRevokeApi;
exports.kxMedalUserListApi = kxMedalUserListApi;
exports.kxPaymentDetailApi = kxPaymentDetailApi;
exports.kxPaymentListApi = kxPaymentListApi;
exports.kxPaymentReviewApi = kxPaymentReviewApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// ==================== 全局配置 ====================

/** 获取所有KX配置 */
function kxConfigListApi() {
  return (0, _request.default)({
    url: '/admin/kx/config/list',
    method: 'get'
  });
}

/** 保存KX配置 */
function kxConfigSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/kx/config/save',
    method: 'post',
    data: data
  });
}

// ==================== 用户账户 ====================

/** 查看用户账户详情 */
function kxAccountInfoApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/account/info',
    method: 'get',
    params: params
  });
}

/** 用户账户列表 */
function kxAccountListApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/account/list',
    method: 'get',
    params: params
  });
}

/** 手动调整资金 */
function kxAccountAdjustApi(data) {
  return (0, _request.default)({
    url: '/admin/kx/account/adjust',
    method: 'post',
    data: data
  });
}

// ==================== 四大流水 ====================

/** 开心果流水列表 */
function kxFlowHappyFruitApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/account/flow/happy-fruit',
    method: 'get',
    params: params
  });
}

/** 佣金流水列表 */
function kxFlowCommissionApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/account/flow/commission',
    method: 'get',
    params: params
  });
}

/** 余额流水列表 */
function kxFlowBalanceApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/account/flow/balance',
    method: 'get',
    params: params
  });
}

/** 专区消费记录列表 */
function kxFlowZoneConsumeApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/account/flow/zone-consume',
    method: 'get',
    params: params
  });
}

// ==================== 直推奖 ====================

/** 直推奖流水列表 */
function kxBonusListApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/bonus/list',
    method: 'get',
    params: params
  });
}

/** 直推奖汇总统计 */
function kxBonusStatApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/bonus/stat',
    method: 'get',
    params: params
  });
}

/** 直推奖详情 */
function kxBonusDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/kx/bonus/detail/".concat(id),
    method: 'get'
  });
}

// ==================== 等级管理 ====================

/** 获取等级配置列表 */
function kxLevelConfigListApi() {
  return (0, _request.default)({
    url: '/admin/kx/level/config/list',
    method: 'get'
  });
}

/** 更新等级配置 */
function kxLevelConfigUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/kx/level/config/update',
    method: 'post',
    data: data
  });
}

/** 用户等级列表 */
function kxLevelUserListApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/level/user-list',
    method: 'get',
    params: params
  });
}

// ==================== 勋章管理 ====================

/** 勋章配置列表 */
function kxMedalConfigApi() {
  return (0, _request.default)({
    url: '/admin/kx/medal/config',
    method: 'get'
  });
}

/** 更新勋章配置 */
function kxMedalConfigUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/kx/medal/config/update',
    method: 'post',
    data: data
  });
}

/** 用户勋章列表 */
function kxMedalUserListApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/medal/user-list',
    method: 'get',
    params: params
  });
}

/** 手动授予勋章 */
function kxMedalGrantApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/medal/grant',
    method: 'post',
    params: params
  });
}

/** 撤销勋章 */
function kxMedalRevokeApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/medal/revoke',
    method: 'post',
    params: params
  });
}

// ==================== 手动入账 ====================

/** 创建手动入账 */
function kxManualCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/kx/manual/create',
    method: 'post',
    data: data
  });
}

/** 审批手动入账 */
function kxManualApproveApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/manual/approve',
    method: 'post',
    params: params
  });
}

/** 手动入账列表 */
function kxManualListApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/manual/list',
    method: 'get',
    params: params
  });
}

/** 手动入账详情 */
function kxManualInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/kx/manual/info/".concat(id),
    method: 'get'
  });
}

// ==================== 支付审核 ====================

/** 支付凭证列表 */
function kxPaymentListApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/payment/list',
    method: 'get',
    params: params
  });
}

/** 审核支付凭证 */
function kxPaymentReviewApi(data) {
  return (0, _request.default)({
    url: '/admin/kx/payment/review',
    method: 'post',
    data: data
  });
}

/** 支付凭证详情 */
function kxPaymentDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/kx/payment/detail/".concat(id),
    method: 'get'
  });
}

// ==================== 代理管理 ====================

/** 代理列表 */
function kxAgentListApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/agent/list',
    method: 'get',
    params: params
  });
}

/** 代理详情 */
function kxAgentInfoApi(uid) {
  return (0, _request.default)({
    url: "/admin/kx/agent/info/".concat(uid),
    method: 'get'
  });
}

/** 取消代理 */
function kxAgentCancelApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/agent/cancel',
    method: 'post',
    params: params
  });
}

/** 团队业绩列表 */
function kxAgentPerformanceApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/agent/performance',
    method: 'get',
    params: params
  });
}

/** 团队业绩导出 */
function kxAgentPerformanceExportApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/agent/performance/export',
    method: 'get',
    params: params
  });
}

// ==================== 邀请码管理 ====================

/** 邀请码列表 */
function kxInviteListApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/invite/list',
    method: 'get',
    params: params
  });
}

// ==================== KX提现管理 ====================

/** KX提现分页列表 */
function kxExtractListApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/extract/list',
    method: 'get',
    params: params
  });
}

/** KX提现审核 */
function kxExtractApplyApi(params) {
  return (0, _request.default)({
    url: '/admin/kx/extract/apply',
    method: 'post',
    params: params
  });
}